import { all, call, put, takeEvery } from 'redux-saga/effects'
import AssetManagementApiService from './AssetManagementApiService'
import { GET_ASSET_READINESS_WORK_BOOK_GRID, GET_AUDIT_DATE_LIST, GET_AUDIT_READINESS_DATE_LIST, GET_AUDIT_TRAINING_DATE_LIST, GET_CURRENT_AUDIT_CYCLE, GET_SAVE_ASSET_READINESS_WORK_BOOK } from '../../Store/AssetManagement/AuditReadinessworkBook/AuditReadinessworkBookType'
import { setAssetReadinessWorkBookGrid, setAuditDateList, setAuditReadinessDateList, setAuditTrainingDateList, setCurrentAuditCycle, setIsDropDownsLoading, setSaveAssetReadinessWorkBook } from 'Store/AssetManagement/AuditReadinessworkBook/AuditReadinessworkBookAction';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { globalLoaderText } from "redux/CommonDashboard/actions";

function* getAssetReadinessWorkBookGridSaga(req: any): any {
    yield put(globalLoaderText("Fetching Grid..."));
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `asset/auditreadywb/grid`,
        payload: req?.payload
    }
    try {
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setAssetReadinessWorkBookGrid(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setAssetReadinessWorkBookGrid([]))
        yield put(globalLoaderText(""));
    }
}

function* getSaveAssetReadinessWorkBookSaga(req: any): any {
    yield put(globalLoaderText("Saving Values..."));
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `asset/auditreadywb`,
        payload: req?.payload
    }
    try {
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setSaveAssetReadinessWorkBook(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setSaveAssetReadinessWorkBook("error"))
        yield put(globalLoaderText(""));
    }
}

function* getAuditDateList(): any {
    yield put(setIsDropDownsLoading(true))
    try {
        let payloadData : IPayload= {                
            apiMethod : apiMethod.GET,    
            apiType : apiType.AssetManagement,    
            endpoint : `asset/auditreadywb/dropdown/auditdate`,
            payload : null
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setAuditDateList(response))
        yield put(setIsDropDownsLoading(false))
    } catch (error) {
        yield put(setAuditDateList([]))
        yield put(setIsDropDownsLoading(false))
    }
}

function* getAuditReadinessDateList(): any {
    yield put(setIsDropDownsLoading(true))
    try {
        let payloadData : IPayload= {                
            apiMethod : apiMethod.GET,    
            apiType : apiType.AssetManagement,    
            endpoint : `asset/auditreadywb/dropdown/auditreadinessdate`,
            payload : null
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setAuditReadinessDateList(response))
        yield put(setIsDropDownsLoading(false))
    } catch (error) {
        yield put(setAuditReadinessDateList([]))
        yield put(setIsDropDownsLoading(false))
    }
}

function* getAuditTrainingDateList(): any {
    yield put(setIsDropDownsLoading(true))
    try {
        let payloadData : IPayload= {                
            apiMethod : apiMethod.GET,    
            apiType : apiType.AssetManagement,    
            endpoint : `asset/auditreadywb/dropdown/audittrainingdate`,
            payload : null
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setAuditTrainingDateList(response))
        yield put(setIsDropDownsLoading(false))
    } catch (error) {
        yield put(setAuditTrainingDateList([]))
        yield put(setIsDropDownsLoading(false))
    }
}

function* getCurrentAuditCycle(): any {
    yield put(setIsDropDownsLoading(true))
    try {
        let payloadData : IPayload= {                
            apiMethod : apiMethod.GET,    
            apiType : apiType.AssetManagement,    
            endpoint : `asset/auditreadywb/auditcycle`,
            payload : null
        }
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setCurrentAuditCycle(response))
        yield put(setIsDropDownsLoading(false))
    } catch (error) {
        yield put(setCurrentAuditCycle({}))
        yield put(setIsDropDownsLoading(false))
    }
}

function* watchGetAssetTypes() {
    yield takeEvery(GET_ASSET_READINESS_WORK_BOOK_GRID, getAssetReadinessWorkBookGridSaga)
    yield takeEvery(GET_SAVE_ASSET_READINESS_WORK_BOOK, getSaveAssetReadinessWorkBookSaga)
    yield takeEvery(GET_AUDIT_DATE_LIST, getAuditDateList)
    yield takeEvery(GET_AUDIT_READINESS_DATE_LIST, getAuditReadinessDateList)
    yield takeEvery(GET_AUDIT_TRAINING_DATE_LIST, getAuditTrainingDateList)
    yield takeEvery(GET_CURRENT_AUDIT_CYCLE,getCurrentAuditCycle)
}

export default function* combinedSaga() {
    yield all([
        watchGetAssetTypes()
    ])
}
